import React from 'react';
import ToolbarContainer from './ToolbarContainer';
import LivefeedPreview from './LivefeedPreview'
import SlidesContainer from './SlidesContainer'
import FloorplanOptionContainer from './FloorplanOptionContainer'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types';

const EditorContainer = ({ editorMode }) => {
    let locationOptionRef = React.useRef(null)
    const dispatch = useDispatch();

    let { mapConfigMode, stepNumberState, livefeedSlides, editorView, slideCurrentIndex } = useSelector(state => state.livefeededitor)
    const nodeMap = useSelector(state => state.overviewReducer.nodeMap)
    const sensorMap = useSelector(state => state.nodeReducer.map)
    return (
        <React.Fragment>
            <ToolbarContainer />
            <div className="livefeed-editor-main flex--center">
                <SlidesContainer />
                <LivefeedPreview
                    scaleMode={false}
                    livefeedSlides={livefeedSlides}
                    slideCurrentIndex={slideCurrentIndex}
                    nodeMap={nodeMap}
                    stepNumberState={stepNumberState}
                    editorView={editorView}
                    sensorMap={sensorMap}
                    mapConfigMode={mapConfigMode}
                    dispatch={dispatch}
                    focusMapApiInput={(e) => { e.stopPropagation(); locationOptionRef.current.focusMapApiInput() }}
                    handleOpenLocationModal={(e) => { e.stopPropagation(); locationOptionRef.current.openLocationsModal() }}
                />
                <FloorplanOptionContainer
                    editorMode={editorMode}
                    ref={locationOptionRef}
                />
            </div>
        </React.Fragment>
    );
}
EditorContainer.propTypes = {
    editorMode: PropTypes.string.isRequired
}

export default EditorContainer;





// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/index.jsx